import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { primitives } from './foundation';
var gap = {
  gap0: primitives.spacing[0],
  gap4: primitives.spacing[4],
  gap8: primitives.spacing[8],
  gap12: primitives.spacing[12],
  gap16: primitives.spacing[16],
  gap24: primitives.spacing[24],
  gap32: primitives.spacing[32],
  gap48: primitives.spacing[48],
  gap64: primitives.spacing[64]
};
var padding = {
  padding0: primitives.spacing[0],
  padding2: primitives.spacing[2],
  padding4: primitives.spacing[4],
  padding8: primitives.spacing[8],
  padding12: primitives.spacing[12],
  padding16: primitives.spacing[16],
  padding20: primitives.spacing[20],
  padding24: primitives.spacing[24],
  padding28: primitives.spacing[28],
  padding32: primitives.spacing[32],
  padding40: primitives.spacing[40],
  padding48: primitives.spacing[48],
  padding64: primitives.spacing[64],
  padding80: primitives.spacing[80],
  padding96: primitives.spacing[96]
};
var section = {
  sectionPaddingLg: primitives.spacing[96],
  sectionPadding: primitives.spacing[64],
  sectionPaddingMin: primitives.spacing[48]
};
var responsive = {
  viewport: '1440px',
  containerMaxWidth: '1280px',
  containerMin1col: '300px',
  containerMin2col: '150px'
};
var radius = {
  radius0: primitives.spacing[0],
  radiusS: primitives.spacing[4],
  radiusSm: primitives.spacing[8],
  radius: primitives.spacing[16],
  radiusMd: primitives.spacing[24],
  radiusRounded: '1000px'
};
var fontSizes = {
  typo10: primitives.fontSize[10],
  typo12: primitives.fontSize[12],
  typo13: primitives.fontSize[13],
  typo14: primitives.fontSize[14],
  typo15: primitives.fontSize[15],
  typo16: primitives.fontSize[16],
  typo17: primitives.fontSize[17],
  typo18: primitives.fontSize[18],
  typo20: primitives.fontSize[20],
  typo22: primitives.fontSize[22],
  typo24: primitives.fontSize[24],
  typo28: primitives.fontSize[28],
  typo30: primitives.fontSize[30],
  typo32: primitives.fontSize[32],
  typo44: primitives.fontSize[44],
  typo48: primitives.fontSize[48],
  typo56: primitives.fontSize[56],
  typo64: primitives.fontSize[64]
};

var sizes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, gap), padding), section), responsive), radius), fontSizes);

export default sizes;